module.exports = __webpack_public_path__ + "static/img/logo.45723da3.png";